/* Copyright Verge Technologies 2018
 * @file specificationPanel.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const SpecificationPanel = (props) => {
  const { activeToggle, specification } = props;
  return (
    <div
      className="panels-page panels-specifications"
      style={{ display: activeToggle === 'SPECIFICATION' ? 'block' : 'none' }}
    >
      {specification && <div className="content" style={{ justifyContent: 'center', alignItems: 'center' }} dangerouslySetInnerHTML={{ __html: specification }} />}
      {!specification && <div className="message">No specification available</div>}
    </div>
  );
};

export default SpecificationPanel;



// WEBPACK FOOTER //
// ./src/components/SpecificationPanel/specificationPanel.js